import window from './window'

export default window.dataLayer || []
export const lazyLoadDataLayer = () => window.dataLayer || []
